import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { autofocus: { type: Boolean, default: false } }

  connect() {
    if (!this.autofocusValue) return

    requestAnimationFrame(() => {
      this.element.scrollIntoView({ block: "nearest", inline: "nearest" })
      this.element.focus()
    })
  }

  open() {
    if (typeof this.element.showPicker === "function") {
      this.element.showPicker()
    }
  }
}
